export const parseJSON = (input: string | null, fallback = '') => {
  if (input) {
    try {
      return JSON.parse(input);
    } catch (e) {
      return fallback;
    }
  } else {
    return fallback;
  }
};
